// Thai translations
export const th: Record<string, string> = {
  'menu.dashboard': 'แดชบอร์ด',
  'menu.orderNew': 'การลงทะเบียนผลิตภัณฑ์',
  'menu.deliveryList': 'รายการจัดส่ง',
  'menu.delivery': 'การจัดส่ง',
  'menu.receipt': 'พิมพ์ใบเสร็จ/ป้ายกำกับ',
  'menu.definitions': 'คำจำกัดความ',
  'menu.customers': 'ลูกค้า',
  'menu.products': 'คำจำกัดความผลิตภัณฑ์',
  'menu.pricing': 'คำจำกัดความราคา',
  'menu.tailoring': 'งานตัดเย็บ',
  'menu.attributes': 'คุณลักษณะผลิตภัณฑ์',
  'menu.users': 'ผู้ใช้',
  'menu.productOrdering': 'การเรียงลำดับผลิตภัณฑ์',
  'menu.discounts': 'คำจำกัดความส่วนลด',
  'menu.settings': 'การตั้งค่า',
  'menu.generalSettings': 'การตั้งค่าทั่วไป',
  'menu.permissions': 'การจัดการสิทธิ์',
  'menu.subscription': 'การสมัครสมาชิก',
  'menu.invoices': 'การจัดการใบแจ้งหนี้',
  'menu.expenses': 'การป้อนค่าใช้จ่าย',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'รายงานและบัญชี',
  'menu.systemAndCommunication': 'ระบบและการสื่อสาร',
  'menu.reportsList': 'รายการใบเสร็จ',
  'menu.accountStatement': 'รายงานบัญชี',
  'menu.tickets': 'คำขอสนับสนุน',
  'menu.support': 'การสนับสนุน',
  'menu.profile': 'โปรไฟล์',
  'menu.logout': 'ออกจากระบบ',
  'menu.notifications': 'การแจ้งเตือน SMS/WhatsApp',
  'menu.whatsappConnection': 'การเชื่อมต่อ WhatsApp',
  'menu.smsConnection': 'การเชื่อมต่อ SMS',
  'dashboard.title': 'แดชบอร์ด',
  'dashboard.todaySales': 'ยอดขายวันนี้',
  'dashboard.totalOrders': 'คำสั่งซื้อทั้งหมด',
  'dashboard.pendingDeliveries': 'การจัดส่งที่รอดำเนินการ',
  'dashboard.activeCustomers': 'ลูกค้าที่ใช้งานอยู่',
  'dashboard.recentOrders': 'คำสั่งซื้อล่าสุด',
  'dashboard.viewAll': 'ดูทั้งหมด',
  'dashboard.quickActions': 'การดำเนินการด่วน',
  'dashboard.newOrder': 'คำสั่งซื้อใหม่',
  'dashboard.newCustomer': 'ลูกค้าใหม่',
  'dashboard.deliveries': 'การจัดส่ง',
  'dashboard.reports': 'รายงาน',
  'dashboard.today': 'วันนี้',
  'dashboard.yesterday': 'เมื่อวาน',
  'dashboard.week': 'สัปดาห์',
  'dashboard.month': 'เดือน',
  'dashboard.quarter': 'ไตรมาส',
  'dashboard.year': 'ปี',
  'dashboard.totalRevenue': 'รายได้ทั้งหมด',
  'dashboard.totalOrdersCard': 'คำสั่งซื้อทั้งหมด',
  'dashboard.totalPieces': 'รายการทั้งหมด',
  'dashboard.cancelled': 'ยกเลิก',
  'dashboard.inProcess': 'กำลังดำเนินการ',
  'dashboard.inProcessDesc': 'คำสั่งซื้อที่กำลังดำเนินการ',
  'dashboard.ready': 'พร้อม',
  'dashboard.readyDesc': 'คำสั่งซื้อที่พร้อมส่ง',
  'dashboard.delivered': 'จัดส่งแล้ว',
  'dashboard.deliveredDesc': 'คำสั่งซื้อที่เสร็จสิ้น',
  'dashboard.announcements': 'ประกาศ',
  'dashboard.announcementAll': 'ทั่วไป',
  'dashboard.announcementPrivate': 'ส่วนตัว',
  'order.title': 'คำสั่งซื้อใหม่',
  'order.customer': 'ลูกค้า',
  'order.selectCustomer': 'เลือกลูกค้า',
  'order.newCustomer': 'ลูกค้าใหม่',
  'order.products': 'ผลิตภัณฑ์',
  'order.addProduct': 'เพิ่มผลิตภัณฑ์',
  'order.selectProduct': 'เลือกผลิตภัณฑ์',
  'order.quantity': 'จำนวน',
  'order.price': 'ราคา',
  'order.total': 'รวม',
  'order.discount': 'ส่วนลด',
  'order.subtotal': 'ยอดรวมย่อย',
  'order.tax': 'ภาษี',
  'order.grandTotal': 'ยอดรวมทั้งหมด',
  'order.payment': 'การชำระเงิน',
  'order.paymentMethod': 'วิธีการชำระเงิน',
  'order.cash': 'เงินสด',
  'order.card': 'บัตรเครดิต',
  'order.credit': 'เครดิต',
  'order.amountPaid': 'จำนวนเงินที่ชำระ',
  'order.remainingBalance': 'ยอดคงเหลือ',
  'order.deliveryDate': 'วันที่จัดส่ง',
  'order.notes': 'หมายเหตุ',
  'order.createOrder': 'สร้างคำสั่งซื้อ',
  'order.cancel': 'ยกเลิก',
  'users.title': 'ผู้ใช้',
  'users.addNew': 'ผู้ใช้ใหม่',
  'users.name': 'ชื่อ',
  'users.email': 'อีเมล',
  'users.role': 'บทบาท',
  'users.pin': 'PIN',
  'users.permissions': 'สิทธิ์',
  'users.allPermissions': 'สิทธิ์ทั้งหมด',
  'users.permissionCount': '{count} สิทธิ์',
  'users.changePin': 'เปลี่ยน PIN',
  'users.edit': 'แก้ไข',
  'users.delete': 'ลบ',
  'users.newUser': 'ผู้ใช้ใหม่',
  'users.editUser': 'แก้ไขผู้ใช้',
  'users.editingUser': 'กำลังแก้ไข {name}',
  'users.deleteUserTitle': 'ลบผู้ใช้',
  'users.deletingUser': 'คุณแน่ใจหรือไม่ว่าต้องการลบ {name}?',
  'users.pinCode': 'รหัส PIN (4-6 หลัก)',
  'users.selectRole': 'เลือกบทบาท',
  'users.patron': 'เจ้าของ',
  'users.kasiyer': 'แคชเชียร์',
  'users.sofor': 'คนขับ',
  'users.changePinTitle': 'เปลี่ยนรหัส PIN',
  'users.newPin': 'รหัส PIN ใหม่',
  'users.confirmPin': 'ยืนยันรหัส PIN',
  'users.pinMismatch': 'รหัส PIN ไม่ตรงกัน',
  'users.pinRequired': 'ต้องการรหัส PIN',
  'users.pinLength': 'รหัส PIN ต้องเป็น 4-6 หลัก',
  'users.changingPinFor': 'กำลังเปลี่ยน PIN สำหรับ {name}',
  'products.title': 'คำจำกัดความผลิตภัณฑ์',
  'products.addNew': 'ผลิตภัณฑ์ใหม่',
  'products.category': 'หมวดหมู่',
  'products.name': 'ชื่อผลิตภัณฑ์',
  'products.price': 'ราคา',
  'products.color': 'สี',
  'products.active': 'ใช้งานอยู่',
  'products.actions': 'การดำเนินการ',
  'products.search': 'ค้นหาผลิตภัณฑ์...',
  'products.noProducts': 'ไม่พบผลิตภัณฑ์',
  'products.noCategoryProducts': 'ไม่มีผลิตภัณฑ์ในหมวดหมู่นี้',
  'products.emptyCart': 'ตะกร้าว่างเปล่า',
  'service.tailor': 'ช่างตัดเสื้อ',
  'service.dryCleaning': 'ซักแห้ง',
  'service.washing': 'ซักผ้า',
  'service.ironing': 'รีดผ้า',
  'service.shoeShine': 'ขัดรองเท้า',
  'service.carpet': 'พรม',
  'service.tailoring': 'การแก้ไขเย็บผ้า',
  'service.carpetWashing': 'ซักพรม',
  'service.selectService': 'เลือกบริการ',
  'service.addToCart': 'เพิ่มในตะกร้า',
  'service.total': 'รวม',
  'common.yes': 'ใช่',
  'common.no': 'ไม่',
  'common.cancel': 'ยกเลิก',
  'common.confirm': 'ยืนยัน',
  'common.delete': 'ลบ',
  'common.edit': 'แก้ไข',
  'common.save': 'บันทึก',
  'common.search': 'ค้นหา',
  'common.loading': 'กำลังโหลด...',
  'common.noData': 'ไม่มีข้อมูล',
  'common.actions': 'การดำเนินการ',
  'common.status': 'สถานะ',
  'common.date': 'วันที่',
  'common.time': 'เวลา',
  'common.total': 'รวม',
  'common.filter': 'กรอง',
  'common.export': 'ส่งออก',
  'common.print': 'พิมพ์',
  'common.close': 'ปิด',
  'common.back': 'กลับ',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': 'ส่ง',
  'common.reset': 'รีเซ็ต',
  'common.create': 'สร้าง',
  'common.creating': 'กำลังสร้าง...',
  'common.later': 'ภายหลัง',
  'common.clear': 'ล้าง',
  'common.copied': 'คัดลอกแล้ว!',
  'common.copyError': 'การคัดลอกล้มเหลว',
  'common.autoDetected': 'ตรวจพบอัตโนมัติ',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.subtitle': 'ระบบจัดการซักแห้ง',
  'login.tenantId': 'รหัสบริษัท',
  'login.tenantPlaceholder': 'รหัส-บริษัท (ตัวอย่าง: acme-clean)',
  'login.tenantIdHelp': 'ป้อนรหัสบริษัทเฉพาะของคุณ',
  'login.continue': 'ดำเนินการต่อ →',
  'login.notMember': 'ยังไม่ได้เป็นสมาชิก?',
  'login.startTrial': 'เริ่มทดลองใช้ฟรี',
  'login.adminLogin': '🔒 เข้าสู่ระบบผู้ดูแล',
  'login.enterPin': 'ป้อนรหัส PIN ของคุณ',
  'login.changeTenant': 'เปลี่ยนบริษัท',
  'login.clear': 'ล้าง',
  'login.delete': 'ลบ',
  'login.login': 'เข้าสู่ระบบ',
  'login.loggingIn': 'กำลังเข้าสู่ระบบ...',
  'login.defaultPinOwner': 'PIN เริ่มต้น: <strong>1234</strong> (เจ้าของ)',
  'login.defaultPinCashier': 'PIN เริ่มต้น: <strong>0000</strong> (แคชเชียร์)',
  'login.systemInitializing': 'กำลังเริ่มต้นระบบ...',
  'login.pinMinLength': 'PIN ต้องมีอย่างน้อย 4 หลัก',
  'login.invalidTenantId': 'ป้อนรหัสบริษัทที่ถูกต้อง',
  'login.tenantNotFound': 'ไม่พบรหัสบริษัทนี้ ตรวจสอบหรือสร้างบัญชีใหม่',
  'login.loginFailed': 'การเข้าสู่ระบบล้มเหลว',
  'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'เริ่มทดลองใช้ฟรี',
  'signup.subtitle': '15 วันฟรี ไม่ต้องใช้บัตรเครดิต',
  'signup.backToLogin': 'กลับไปยังหน้าเข้าสู่ระบบ',
  'signup.companyCode': 'รหัสบริษัท',
  'signup.companyCodePlaceholder': 'ตัวอย่าง: cleanpro',
  'signup.companyCodeHelp': 'รหัสนี้จะใช้สำหรับเข้าสู่ระบบ',
  'signup.companyCodeMinLength': 'รหัสบริษัทต้องมีอย่างน้อย 3 ตัวอักษร',
  'signup.companyName': 'ชื่อบริษัท',
  'signup.companyNamePlaceholder': 'ชื่อบริษัทของคุณ',
  'signup.companyNameRequired': 'ต้องการชื่อบริษัท',
  'signup.fullName': 'ชื่อเต็ม',
  'signup.fullNamePlaceholder': 'ชื่อเต็มของคุณ',
  'signup.fullNameRequired': 'ต้องการชื่อเต็ม',
  'signup.phone': 'โทรศัพท์',
  'signup.phonePlaceholder': '+66 82 345 6789',
  'signup.validPhoneRequired': 'ป้อนหมายเลขโทรศัพท์ที่ถูกต้อง',
  'signup.email': 'อีเมล',
  'signup.emailPlaceholder': 'example@company.com',
  'signup.validEmailRequired': 'ป้อนที่อยู่อีเมลที่ถูกต้อง',
  'signup.createAccount': 'สร้างบัญชี',
  'signup.creating': 'กำลังสร้าง...',
  'signup.terms': 'การสร้างบัญชี คุณยอมรับข้อกำหนดการบริการและนโยบายความเป็นส่วนตัว',
  'signup.success': 'ลงทะเบียนสำเร็จ! ข้อมูลการเข้าสู่ระบบของคุณถูกส่งไปยังอีเมลของคุณแล้ว',
  'signup.successTitle': 'ลงทะเบียนสำเร็จ!',
  'signup.successMessage': 'บัญชีของคุณถูกสร้างสำเร็จแล้ว',
  'signup.emailSent': 'ข้อมูลการเข้าสู่ระบบของคุณถูกส่งไปยังอีเมลของคุณแล้ว',
  'signup.redirecting': 'กำลังเปลี่ยนเส้นทางไปยังหน้าเข้าสู่ระบบ...',
  'signup.startupPackageLoaded': 'โหลดแพ็กเกจเริ่มต้นแล้ว!',
  'signup.products': 'ผลิตภัณฑ์',
  'signup.customers': 'ลูกค้า',
  'signup.users': 'ผู้ใช้',
  'signup.demoDataReady': '✨ ข้อมูลสาธิตของคุณพร้อมแล้ว คุณสามารถเริ่มใช้งานได้ทันที!',
  'signup.loginInfo': '📧 ข้อมูลการเข้าสู่ระบบของคุณ',
  'signup.loginInfoSent': '💡 ข้อมูลนี้ถูกส่งไปยังอีเมลของคุณด้วย',
  'signup.loginNow': 'เข้าสู่ระบบเดี๋ยวนี้ →',
};
